import { useEffect, useState } from "react";
import { Text } from "../../../../../../../components/common";
import {
  CurrencyName,
  CurrencyOption,
  CurrencySelector,
  RadioButton,
} from "./index.styled";
import { LabelContainer } from "../label-input/label-input.styled";
import { useTheme } from "styled-components";
import { DEFAULT_CURRENCIES } from "../../../../../../../utils/constants";

interface CurrencySelectProps {
  label: string;
  currency: string;
  onChange: (Currency: string) => void;
}

export const CurrencySelect: React.FC<CurrencySelectProps> = ({
  label,
  currency,
  onChange,
}) => {
  const [selectedCurrency, setSelectedCurrency] = useState(currency);
  const currencies = DEFAULT_CURRENCIES;
  const theme = useTheme();

  useEffect(() => {
    setSelectedCurrency(currency);
  }, [currency]);

  return (
    <>
      <LabelContainer>
        <Text
          color={theme.colors.primaryBlue.main}
          fontWeight={600}
          fontSize={15}
          margin="0 0 .5rem 0"
        >
          {label}
        </Text>
      </LabelContainer>
      <CurrencySelector>
        {currencies.map((currency) => (
          <CurrencyOption key={currency.value}>
            <RadioButton
              name="Currency"
              value={currency.value}
              checked={selectedCurrency === currency.value}
              onChange={() => {
                setSelectedCurrency(currency.value);
                onChange(currency.value);
              }}
            />
            <CurrencyName>{`${currency.value} - ${currency.label}`}</CurrencyName>
          </CurrencyOption>
        ))}
      </CurrencySelector>
    </>
  );
};
